// extracted by mini-css-extract-plugin
export default {"headerBar":"VM-z","pointsSection":"WM-z","goToDashboard":"XM-z"};